import Button from "../Common/Button";
import {VARIANT} from "../../constants";
import merchantStore from "../../store/merchantStore";
import {useState} from "react";

const Account = ({setChangePassword}) => {
	const {merchantProfile} = merchantStore() || {};
	const {phone_number} = merchantProfile || {};
	
	return (
		<div className='grid gap-5 text-sm acc-section'>
			<div>Tài khoản</div>
			<div className='text-[#9E9E9E]'>{phone_number || ''}</div>
			<div>Mật khẩu hiện tại</div>
			<div className='w-[210px] px-0 border-none text-[#9E9E9E]'>***************</div>
			<Button className='w-[140px]' variant={VARIANT.PRIMARY} onClick={setChangePassword}>Đổi mật khẩu</Button>
		</div>
	)
}

export default Account;
